import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Rating from 'widgets/Rating/Rating';
import CatchWeight from './CatchWeight';
import { scrollToReviews } from '../../utils/createReview';
import { requestLogin } from 'utils/loginAndRegistration/login';

export default class Title extends PureComponent {
  static propTypes = {
    product: PropTypes.shape({
      name: PropTypes.string,
      optionName: PropTypes.string,
      catchWeight: PropTypes.string,
      packInfo: PropTypes.object,
      deranged: PropTypes.bool,
    }),
    reviewStats: PropTypes.object,
    userRatedProduct: PropTypes.bool,
    setModalVisibility: PropTypes.func.isRequired,
    showCatchweight: PropTypes.bool,
    router: PropTypes.object,
    isLoggedIn: PropTypes.bool,
  };

  render() {
    const { name, optionName, catchWeight, deranged = false } = this.props.product;
    const { reviewStats, userRatedProduct, showCatchweight, router, isLoggedIn } = this.props;

    return (
      <>
        <h1>{optionName || name} {!showCatchweight && <CatchWeight catchWeight={catchWeight} />}</h1>
        {!deranged && (
          <div className="bop-titleInfoWrapper">
            <a
              href="#reviews"
              className="bop-titleInfo"
              onClick={(e) => {
                e.preventDefault();
                scrollToReviews();
              }}
            >
              {reviewStats
                ? <Rating reviewStats={reviewStats} />
                : (
                  <Rating reviewStats={{
                    averageRate: 0,
                    count: 0,
                  }}
                  />
                )}
            </a>
            {!userRatedProduct && (
              <a
                href="#reviews"
                className="bop-title__leaveAReview"
                onClick={(e) => {
                  e.preventDefault();
                  if (isLoggedIn) {
                    this.props.setModalVisibility(true);
                  } else {
                    requestLogin(router);
                  }
                }}
              >
                Leave a review
              </a>
            )}
          </div>
        )}
      </>
    );
  }
}

